import styled from '@emotion/styled'
import { breakpoint, breakpointMax, calcRem, metrics } from '../../../__styling'

export const StyledStaticPageContainer = styled('div')(({ theme }) => [
    {
        h1: {
            marginTop: 0,
            marginBottom: calcRem(metrics.thenightly.margins.lg),
        },
        'h3, p': {
            marginTop: 0,
            marginBottom: calcRem(metrics.thenightly.margins.sm),
        },

        [breakpointMax('xxs')]: {
            height: '70vh',
            display: 'flex',
            flexDirection: 'column',
        },

        button: {
            width: '100%',

            // DEVICE STYLING
            marginTop: calcRem(metrics.thenightly.margins.md),
            marginBottom: 0,

            // TABLET AND ABOVE STYLING
            [breakpoint('xxs')]: {
                marginLeft: 'auto',
                marginRight: 'auto',
                width: 'auto',
                marginTop: calcRem(metrics.thenightly.margins.xxxl),
            },
            // LAPTOP AND ABOVE STYLING
            [breakpoint('lg')]: {
                marginLeft: 0,
                marginRight: 0,
                marginTop: calcRem(metrics.thenightly.margins.lg),
            },
        },
    },
    // PerthNow styling
    theme.kind === 'perthnow' && {
        'h3, p': {
            marginBottom: 0,
        },
    },
])
StyledStaticPageContainer.displayName = 'StyledStaticPageContainer'
